import { render, staticRenderFns } from "./SendToSupplierForm.vue?vue&type=template&id=bf754398&"
import script from "./SendToSupplierForm.vue?vue&type=script&lang=js&"
export * from "./SendToSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports